 <template>
  <div id="members">
      <div class="row">
      <div class="col-12 d-flex justify-content-between flex-wrap">
        <div style="flex:1;" class="d-flex align-items-center">
          <h2 class="view-title">Exportar cotizaciones</h2>
        </div>
        <div class="container-actions-dashboard d-flex justify-content-end mt-2 mt-sm-2 mt-md-0 mt-lg-0 mt-xl-0">
          <router-link class="btn btn-outlined mr-2 d-flex align-items-center" to="/configuracion">
            <img src="@/assets/icons/undo.svg" width="15px" class="mr-2"/>
            Regresar a configuración
          </router-link>
          <button class="btn btn-save d-flex align-items-center">
              <img src="@/assets/icons/guardar.svg" width="18" class="mr-2">
            Guardar cambios
          </button>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mt-2">
        <p class="content-text">
          Descarga un reporte de todas tus cotizaciones en formato xls. Esto te permitirá abrirlo en tu hoja de cálculo preferida y crear reportes internos de ventas de forma rápida y eficiente.
        </p>
      </div>
    </div>
    <div class="row mb-5">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div class="cotizarlo-general-wrapper wrapper-padding">
                <h3 class="subtitle-section">Descarga tus cotizaciones</h3>
                <div class="row mt-3">
                    <div class="col d-flex align-items-center">
                        <div class="form-group mb-0">
                            <div class="input-group flex-nowrap d-flex">
                                <div class="input-group-prepend flex-fill">
                                    <div class="input-group-text w-100">
                                        Fecha
                                    </div>
                                </div>
                                <div class="input-append-select flex-fill">
                                    <button class="cotizarlo-select dropdown-toggle my-0" type="button" id="menuExport" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border:none">
                                        <span>{{period.value}}</span>
                                        <img class="dropdown-icon mx-2" src="@/assets/icons/abajo_blue.svg" width="15px"/>
                                    </button>
                                    <div class="dropdown-menu dropdown-select-menu dropdown-menu-right" aria-labelledby="menuExport">                  
                                        <div class="dropdown-item d-flex py-1" @click="selectPeriod('15days', 'Últimos 15 días')">
                                            <span>15 días</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1" @click="selectPeriod('30days', 'Últimos 30 días')">
                                            <span>30 días</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1"  @click="selectPeriod('90days', 'Últimos 90 días')">
                                            <span>90 días</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1" @click="selectPeriod('year', 'Ùltimo año')">
                                            <span>Ùltimo año</span>
                                        </div> 
                                        <div class="dropdown-item d-flex py-1" @click="selectPeriod('All', 'Todas')">
                                            <span>Todas</span>
                                        </div>
                                    </div>       
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                      <button class="btn btn-simple" @click="getPeriodData()">
                        Descargar
                      </button>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import quotationListService from "@/api/quotation_list";

export default {
  data() {
    return {
      period: {
        period:'15days',
        value: " Ùltimos 15 días"
      }
    }
  },
  methods: {
    selectPeriod(period, value){
      this.period.period = period
      this.period.value = value
    },
    getPeriodData(){
      let data = new FormData()
      data.append("period", this.period.period)

      let elements = []

      quotationListService
      .exportQuotation(data)
      .then((response) => {
        elements = response.data.split(",")
        this.createRows(elements)
      })
      .catch(() => {
        this.$store.dispatch('showLoader',{show:false});
      });
    },
    createRows(elements){
      let numberRows = elements.length / 11
      let rows = []

      for(let i=1 ; i<=numberRows; i++){
        let tempRow = []

        if(elements.length != 0){
          tempRow.push(elements.slice(0,11))
          elements.splice(0,11)
          rows.push(tempRow)
        }
      }
      this.download(rows)
    },
    download(rows){
      let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n")
      var encodedUri = encodeURI(csvContent);
      window.open(encodedUri);

    }
  },
}
</script>
